/**
 * Created by Carsten Bühler
 * User: c.buehler on 09.06.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';


import React from 'external/react';
import { translation } from 'plugin/liferay-widgets-react-web';

const DataSourcesTableHeader = () => {
    return (
        <tr>
            <th>{translation.trans('title')}</th>
            <th>{translation.trans('type')}</th>
            <th>{translation.trans('config')}</th>
            <th>{translation.trans('actions')}</th>
        </tr>
    );
};

DataSourcesTableHeader.propTypes = {};

export default DataSourcesTableHeader;




// WEBPACK FOOTER //
// ./js/components/DataSourcesTableHeader.jsx